import { useCallback, useEffect, useState } from "react";
import { clearSession, decodeIdTokenClaims, getSession, logout as cognitoLogout } from "../utils/cognitoAuth";

/**
 * Provides the current admin session (if any) derived from the Cognito
 * tokens stored in sessionStorage, plus a logout helper. Re-checks on
 * mount and whenever the tab regains focus (in case the session expired).
 */
export default function useAuth() {
  const [session, setSession] = useState(() => getSession());

  const refresh = useCallback(() => {
    setSession(getSession());
  }, []);

  useEffect(() => {
    window.addEventListener("focus", refresh);
    return () => window.removeEventListener("focus", refresh);
  }, [refresh]);

  const claims = session ? decodeIdTokenClaims(session.idToken) : null;

  const logout = useCallback(() => {
    clearSession();
    cognitoLogout();
  }, []);

  return {
    isAuthenticated: Boolean(session),
    idToken: session?.idToken || null,
    email: claims?.email || null,
    refresh,
    logout,
  };
}
